import { render } from "./ChiTietBaiVietGiaoDuc.vue?vue&type=template&id=b9e8fada&scoped=true"
import script from "./ChiTietBaiVietGiaoDuc.vue?vue&type=script&lang=js"
export * from "./ChiTietBaiVietGiaoDuc.vue?vue&type=script&lang=js"

import "./ChiTietBaiVietGiaoDuc.vue?vue&type=style&index=0&id=b9e8fada&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e8fada"]])

export default __exports__